import { VesselComponentModule } from './../vessel/vessel.module';
import { VesselVisitDocumentViewComponent } from './components/vessel-document-view/vessel-visit-document-view.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateView } from '@common/guards/view.deactivate';
import { ViewMode } from '@common/models/view-mode';
import { CommonModule } from '@common/common.module';
import { GeneralDataSegment } from './components/segments/general-data-segment/general-data-segment.component';
import { OperationalPlanApprovalsHistorySegment } from './components/segments/operational-plan-approvals-history-segment/operational-plan-approvals-history-segment.component';
import { AccommodationRequestApprovalsHistorySegment } from './components/segments/accommodation-request-approvals-history-segment/accommodation-request-approvals-history-segment.component';
import { ApprovalsHistorySegment } from './components/segments/approvals-history-segment/approvals-history-segment.component';
import { AccommodationRequestSegment } from './components/segments/accommodation-request-segment/accommodation-request-segment.component';
import { ReceiptConfirmationSegment } from './components/segments/receipt-confirmation-segment/receipt-confirmation-segment.component';
import { AddProposedBerthComponent } from './components/add-proposed-berth/add-proposed-berth.component';
import { CanEditGuard } from '@common/guards/can-edit.guard';
import { CanViewGuard } from '@common/guards/can-view.guard';

export const VESSEL_VISIT_DOCUMENT_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
    },
    {
        path: 'view/:id',
        component: VesselVisitDocumentViewComponent,
        data: {
            mode: ViewMode.view
        },
        canActivate: [CanViewGuard],
    },
    {
        path: 'edit/:id',
        component: VesselVisitDocumentViewComponent,
        data: {
            mode: ViewMode.edit
        },
        canDeactivate: [CanDeactivateView],
        canActivate: [CanEditGuard],
    },
    {
        path: 'create',
        component: VesselVisitDocumentViewComponent,
        data: {
            mode: ViewMode.create
        },
        canDeactivate: [CanDeactivateView]
    },
    {
        path: '**',
        redirectTo: 'list'
    }
];

@NgModule({
    imports: [CommonModule, VesselComponentModule],
    declarations: [ 
        VesselVisitDocumentViewComponent, 
        GeneralDataSegment, 
        OperationalPlanApprovalsHistorySegment,
        AccommodationRequestApprovalsHistorySegment,
        ApprovalsHistorySegment,
        AccommodationRequestSegment,
        ReceiptConfirmationSegment,
        AddProposedBerthComponent
    ],
    exports: [CommonModule],
    providers: [CanDeactivateView]
})
export class VesselVisitDocumentComponentModule { }

@NgModule({
    imports: [
        RouterModule.forChild(VESSEL_VISIT_DOCUMENT_ROUTES), VesselVisitDocumentComponentModule,
    ],
    declarations: [],
    providers: [CanDeactivateView]
})
export class VesselVisitDocumentModule { }


